import { type FC } from 'react';
import { type FacilitiesIconProps } from './types';

const Transport: FC<FacilitiesIconProps> = ({ width, height, fill }) => (
  <svg
    width={width || '65'}
    height={height || '65'}
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.0355 27.0449C25.4074 27.8949 26.6825 27.3636 26.3106 26.5136L25.62 24.8666L29.8702 23.804L36.8832 24.8666C37.7864 25.026 37.9989 23.6446 37.0957 23.4853C36.1394 23.379 30.0296 22.3164 29.6577 22.4227L24.5042 23.6978C24.0792 23.7509 23.8136 24.2291 24.0261 24.6541L25.0355 27.0449ZM18.3413 36.3955L14.091 29.17L16.0568 28.6387L20.5196 32.464C20.7321 32.6234 20.9978 32.6765 21.2103 32.5703C28.1701 30.392 43.7368 24.4947 50.4842 26.0886C51.4405 26.3011 51.5467 26.3542 50.8029 26.9386C48.5184 28.9575 40.6022 31.0826 40.2835 31.5077L30.5078 43.1429L27.3732 43.0897L27.9045 35.3861C27.9045 35.0142 27.6388 34.6954 27.2669 34.6423C26.4169 34.5891 19.7227 36.1299 18.3413 36.3955ZM18.1288 37.83L26.47 36.183L25.9387 43.7273C25.9387 44.0992 26.2575 44.4179 26.6294 44.4179L30.7734 44.5242C30.9859 44.5773 31.1985 44.4711 31.3578 44.3117L41.2398 32.5703C46.8714 30.8701 50.3248 29.2763 51.7593 28.0012C53.3531 26.6198 52.8218 25.1854 50.8029 24.7072C43.6306 23.0602 28.4358 28.8512 21.104 31.1358L16.6943 27.3636C16.535 27.2043 16.2693 27.098 16.0037 27.2043L12.8159 28.1074C12.3909 28.2137 12.1784 28.745 12.444 29.1169L17.385 37.5112C17.5444 37.7769 17.8632 37.8831 18.1288 37.83Z"
      fill={fill || '#505050'}
    />
  </svg>
);

export default Transport;
